import { useMemo } from 'react';
import { FiservCardInterface } from '@common-fe/common-fe';

import { useGetCardsQuery } from '@/modules/transaction/queries/useGetCards.query';
import { useAuthStore } from '@/modules/user/stores';


export default ({ cardId }: { cardId: string | null }) => {
  const { user } = useAuthStore();
  const {
    cardList,
    refetch,
    isLoading,
  } = useGetCardsQuery(user?.employee?.id);

  const card = useMemo(() => cardList
    .find((item) => `${item.id}` === cardId),
  [cardList, cardId]);

  const preparedCard = useMemo(() => ({
    status: card?.status,
    last4Number: card?.last4Number || '',
    holder: card?.holder || {},
    id: `${card?.id}`,
    bankType: card?.bankType,
    primary: card?.primary,
    expDate: card?.expDate,
    cardRequestDate: card?.cardRequestDate,
    mailedDate: card?.mailedDate,
    activationDate: card?.activationDate,
    employeeUnlockForbidden: card?.employeeUnlockForbidden,
    cardAccountId: card?.cardAccountId,
    cardPurses: card?.cardPurses,
    lockReason: card?.lockReason,
  }), [card]);

  return {

    card: preparedCard as FiservCardInterface,
    isLoading,
    refetch,
  };
};
